import './style.scss';

// 暂无数据
export default function NoData({ text = '暂无内容' }) {
  return <div className="no-data">
    <i className="iconfont icon-msg"></i>
    <p>{text}</p>
  </div>
}